import {
  ClaimedDatabaseResource,
  DataGroupItemResponse,
} from '@ariksa/abac/api';
import { find, isEmpty, some } from 'lodash';

// A resource belongs to at most one data group: no two groups may hold the
// same resource or one inside the other. Names compare ignoring case, as the
// server does for Snowflake's unquoted identifiers.
const sameName = (first?: string, second?: string) =>
  !!first && !!second && first.toLowerCase() === second.toLowerCase();

export const findClaimedDatabase = (
  claimed: ClaimedDatabaseResource[] | undefined,
  databaseName?: string,
) => find(claimed, c => sameName(c.database_name, databaseName));

// Another group holds the whole database, so none of it can be picked.
export const isWholeDatabaseClaimed = (
  claimedDatabase?: ClaimedDatabaseResource,
) => !!claimedDatabase?.whole_database;

// Another group holds some of its schemas, so the database cannot be added
// whole: specific schemas must be picked instead.
export const hasClaimedSchemas = (claimedDatabase?: ClaimedDatabaseResource) =>
  !isEmpty(claimedDatabase?.schemas);

export const isSchemaClaimed = (
  claimedDatabase: ClaimedDatabaseResource | undefined,
  schemaName?: string,
) => some(claimedDatabase?.schemas, schema => sameName(schema, schemaName));

// The group being edited already holds the database whole. The server only
// checks newly added resources, so keeping such a database is still allowed.
export const isDatabaseHeldWhole = (
  items: DataGroupItemResponse[] | undefined,
  databaseName?: string,
) =>
  some(
    items,
    item => !item.schema_name && sameName(item.database_name, databaseName),
  );
